import { render, staticRenderFns } from "./CartaPorte.vue?vue&type=template&id=020b0992&"
import script from "./CartaPorte.vue?vue&type=script&lang=js&"
export * from "./CartaPorte.vue?vue&type=script&lang=js&"
import style0 from "./CartaPorte.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports